module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/GuaranteedOrigins_CertifiedOrigins_bg.d344a408.jpg";